import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

// =============================================================================
// BLOCK TMSCR.1 — Outstanding Orders TMS Child Row Component
// Displays line item information (ItemCode, Qty) for expanded parent orders
// =============================================================================
function OutstandingOrdersTMSChildRow({ order }) {
  // BLOCK TMSCR.1.1 — Destructure child-level order fields
  const { ItemCode, QTY, SalesOrderNo, LineKey } = order;

  // BLOCK TMSCR.1.2 — Render child row with indentation
  return (
    <TableRow
      hover
      sx={{
        '&:hover': { backgroundColor: (theme) => theme.palette.action.hover },
        backgroundColor: (theme) => theme.palette.action.disabled,
      }}
      data-cy={`child-row-${SalesOrderNo}-${LineKey}`}
    >
      {/* BLOCK TMSCR.1.3 — Empty cell for alignment with expand button */}
      <TableCell
        sx={{ padding: '8px', width: '40px', color: (theme) => theme.palette.text.primary }}
        data-cy="cell-child-spacer"
      />

      {/* BLOCK TMSCR.1.4 — Empty cell for alignment with Sales Order # column */}
      <TableCell
        sx={{ padding: '8px', color: (theme) => theme.palette.text.primary }}
        data-cy="cell-child-align-salesorder"
      />

      {/* BLOCK TMSCR.1.4A — Empty cell for alignment with Time Created column */}
      <TableCell
        sx={{ padding: '8px', color: (theme) => theme.palette.text.primary }}
        data-cy="cell-child-align-timecreated"
      />

      {/* BLOCK TMSCR.1.5 — Item Code Column (aligned with Order Date) */}
      <TableCell
        sx={{
          padding: '8px',
          whiteSpace: 'nowrap',
          fontWeight: 500,
          color: (theme) => theme.palette.text.primary,
        }}
        data-cy="cell-ItemCode"
      >
        {ItemCode || '—'}
      </TableCell>

      {/* BLOCK TMSCR.1.6 — Quantity Column (aligned with Facility) */}
      <TableCell
        sx={{ padding: '8px', whiteSpace: 'nowrap', color: (theme) => theme.palette.text.primary }}
        data-cy="cell-QTY"
      >
        {QTY || '—'}
      </TableCell>

      {/* BLOCK TMSCR.1.7 — Empty cells for alignment with remaining parent columns */}
      <TableCell
        sx={{ padding: '8px', color: (theme) => theme.palette.text.primary }}
        data-cy="cell-child-align-shipto"
      />
      <TableCell
        sx={{ padding: '8px', color: (theme) => theme.palette.text.primary }}
        data-cy="cell-child-align-custpo"
      />
      <TableCell
        sx={{ padding: '8px', color: (theme) => theme.palette.text.primary }}
        data-cy="cell-child-align-shipvia"
      />
      <TableCell
        sx={{ padding: '8px', color: (theme) => theme.palette.text.primary }}
        data-cy="cell-child-align-shipstatus"
      />
    </TableRow>
  );
}

OutstandingOrdersTMSChildRow.propTypes = {
  order: PropTypes.shape({
    ItemCode: PropTypes.string,
    QTY: PropTypes.string,
    SalesOrderNo: PropTypes.string,
    LineKey: PropTypes.string,
  }).isRequired,
};

export default OutstandingOrdersTMSChildRow;
